import { IdsIcon } from '@ids/react';

import { If } from '@mobi/components';

import './ServicesGrid.scss';

const ServicesGrid = ({ title, maintitle, services, isUniclass = false }) => {
  return (
    <section className="services-grid">
      <div className="services-grid__content">
        <div className="services-grid__texts">
          <h3
            className={`services-grid__title ${
              isUniclass ? 'uniclass' : 'variant'
            }`}
          >
            {title}
          </h3>
          <h2 className="services-grid__maintitle">{maintitle}</h2>
        </div>

        <ul className="services-grid__list">
          {services.map(({ title, text, icon, Image }, index) => (
            <li key={index} className="services-grid__item">
              <If condition={icon}>
                <IdsIcon
                  className={`services-grid__item-icon ${
                    isUniclass ? 'uniclass' : 'variant'
                  }`}
                  size="xl"
                >
                  {icon}
                </IdsIcon>
              </If>
              <If condition={!icon && Image}>
                <Image
                  className={`services-grid__item-icon ${
                    isUniclass ? 'uniclass' : 'variant'
                  }`}
                />
              </If>
              <h3 className="services-grid__item-title">{title}</h3>
              <p className="services-grid__item-text">
                {text.map((text, idx) => {
                  return (
                    <>
                      {idx >= 1 ? <br /> : ''}
                      {text}
                    </>
                  );
                })}
              </p>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default ServicesGrid;
